import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Star, Clock, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="relative bg-[#FDFBF7] overflow-hidden" data-id="element-76">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-77">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-78">
          <defs data-id="element-79">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-80">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-81" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-82" />
        </svg>
      </div>

      <div className="container mx-auto px-4 pt-12 pb-20 md:pt-20 md:pb-28 relative z-10" data-id="element-83">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-84">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-85">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold mb-6 border border-amber-200" data-id="element-86">
              <Star className="w-4 h-4 fill-amber-500 text-amber-500" data-id="element-87" />
              <span data-id="element-88">El Secreto de la Pastelería Francesa</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-stone-900 leading-tight mb-6" data-id="element-89">
              ¿Por qué el Mil Hojas de pastelería dura días crujiente y el tuyo
              se ablanda en{' '}
              <span className="text-amber-600 italic" data-id="element-90">20 minutos</span>?
            </h1>

            <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-91">
              Descubre el secreto del{' '}
              <strong className="text-stone-900" data-id="element-92">"Escudo de Cristal"</strong> y
              olvídate del hojaldre chicloso para siempre.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10" data-id="element-93">
              <Button size="lg" className="w-full sm:w-auto text-lg shadow-amber-200/50" onClick={scrollToOffer} data-id="element-94">
                Obtener la Guía Maestra - $6.39
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-95" />
              </Button>
              <p className="text-xs text-stone-500 mt-2 sm:mt-0 sm:hidden" data-id="element-96">
                Acceso inmediato • Garantía de 30 días
              </p>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-6 text-sm text-stone-500 font-medium" data-id="element-97">
              <div className="flex items-center gap-2" data-id="element-98">
                <Clock className="w-4 h-4 text-amber-600" data-id="element-99" />
                <span data-id="element-100">Lectura rápida</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-101">
                <ShieldCheck className="w-4 h-4 text-amber-600" data-id="element-102" />
                <span data-id="element-103">Técnica probada</span>
              </div>
            </div>
          </div>

          {/* Product Image */}
          <div className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-104">
            <div className="absolute inset-0 bg-amber-200 rounded-2xl rotate-3 transform scale-95 opacity-50 blur-xl" data-id="element-105"></div>
            <img src="https://cdn.magicpatterns.com/uploads/tw6KWHMb7t51djdwgghJH6/portada.png" alt="Mil Hojas Pro Guide on iPad" className="relative w-full h-auto rounded-xl shadow-2xl border-4 border-white transform hover:scale-[1.01] transition-transform duration-500" data-id="element-106" />

            {/* Float Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-xl border border-stone-100 hidden md:block" data-id="element-107">
              <div className="flex items-center gap-3" data-id="element-108">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-109">
                  <ShieldCheck className="w-6 h-6 text-green-600" data-id="element-110" />
                </div>
                <div data-id="element-111">
                  <p className="text-xs text-stone-500 uppercase font-bold tracking-wider" data-id="element-112">
                    Resultado
                  </p>
                  <p className="text-stone-900 font-bold" data-id="element-113">100% Crujiente</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}